import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import { InvoiceFiscalProfileTaxRegime } from "src/app/backend/models/invoice/invoice";
import {
  Regions,
  RegionService
} from "src/app/services/feature-access-control/region.service";
import { sntTranslate } from "src/app/support/translate";

@Injectable()
export class FiscalProfileService {
  private readonly regionService = inject(RegionService);

  getDevxDataSourceByRegion(): DataSource {
    switch (this.regionService.get()) {
      case Regions.AE: {
        return new DataSource({
          paginate: false,
          store: new ArrayStore({
            data: [
              {
                display: sntTranslate(marker("Regime ordinario")),
                value: InvoiceFiscalProfileTaxRegime.NORMAL_REGIME
              },
              {
                display: sntTranslate(marker("Regime forfettario")),
                value: InvoiceFiscalProfileTaxRegime.FLAT_TAX_REGIME
              }
            ]
          })
        });
      }
      default: {
        return new DataSource({
          paginate: false,
          store: new ArrayStore({
            data: [
              {
                display: sntTranslate(marker("Regime ordinario")),
                value: InvoiceFiscalProfileTaxRegime.NORMAL_REGIME
              },
              {
                display: sntTranslate(marker("Regime forfettario")),
                value: InvoiceFiscalProfileTaxRegime.FLAT_TAX_REGIME
              },
              {
                display: sntTranslate(marker("Regime dei minimi")),
                value: InvoiceFiscalProfileTaxRegime.FACILITATED_TAX_SYSTEM
              }
            ]
          })
        });
      }
    }
  }
}
